/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDiaglabBills } from 'app/entities/diaglab-bill/diaglab-bill.reducer';
import { getEntities as getDiaglabAssistants } from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import { SamplePriority } from 'app/shared/model/enumerations/sample-priority.model';
import { SourceOfSample } from 'app/shared/model/enumerations/source-of-sample.model';
import { SampleStatus } from 'app/shared/model/enumerations/sample-status.model';
import { TypeOfSample } from 'app/shared/model/enumerations/type-of-sample.model';
import { UOM } from 'app/shared/model/enumerations/uom.model';
import { createEntity, getEntity, reset, updateEntity } from './diaglab-sample.reducer';

export const DiaglabSampleUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diaglabBills = useAppSelector(state => state.diaglabBill.entities);
  const diaglabAssistants = useAppSelector(state => state.diaglabAssistant.entities);
  const diaglabSampleEntity = useAppSelector(state => state.diaglabSample.entity);
  const loading = useAppSelector(state => state.diaglabSample.loading);
  const updating = useAppSelector(state => state.diaglabSample.updating);
  const updateSuccess = useAppSelector(state => state.diaglabSample.updateSuccess);
  const samplePriorityValues = Object.keys(SamplePriority);
  const sourceOfSampleValues = Object.keys(SourceOfSample);
  const sampleStatusValues = Object.keys(SampleStatus);
  const typeOfSampleValues = Object.keys(TypeOfSample);
  const uOMValues = Object.keys(UOM);

  const handleClose = () => {
    navigate(`/diaglab-sample${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
    dispatch(getDiaglabBills({}));
    dispatch(getDiaglabAssistants({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.quantity !== undefined && typeof values.quantity !== 'number') {
      values.quantity = Number(values.quantity);
    }
    if (values.collectionDate !== undefined && typeof values.collectionDate !== 'number') {
      values.collectionDate = Number(values.collectionDate);
    }
    if (values.revision !== undefined && typeof values.revision !== 'number') {
      values.revision = Number(values.revision);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...diaglabSampleEntity,
      ...values,
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
      labBill: diaglabBills.find(it => it.id.toString() === values.labBill?.toString()),
      collector: diaglabAssistants.find(it => it.id.toString() === values.collector?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          priority: 'HIGH',
          sourceOfSample: 'IP',
          status: 'NotTested',
          typeOfSample: 'Serum',
          uom: 'Femtoliters',
          ...diaglabSampleEntity,
          diagLab: diaglabSampleEntity?.diagLab?.id,
          labBill: diaglabSampleEntity?.labBill?.id,
          collector: diaglabSampleEntity?.collector?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diaglabSample.home.createOrEditLabel" data-cy="DiaglabSampleCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diaglabSample.home.createOrEditLabel">Create or edit a DiaglabSample</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diaglab-sample-id"
                  label={translate('tinyMedicRestApp.diaglabSample.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.accessionNumber')}
                id="diaglab-sample-accessionNumber"
                name="accessionNumber"
                data-cy="accessionNumber"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.domain')}
                id="diaglab-sample-domain"
                name="domain"
                data-cy="domain"
                type="text"
                validate={{
                  maxLength: { value: 1, message: translate('entity.validation.maxlength', { max: 1 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.clientReferenceRemarks')}
                id="diaglab-sample-clientReferenceRemarks"
                name="clientReferenceRemarks"
                data-cy="clientReferenceRemarks"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.priority')}
                id="diaglab-sample-priority"
                name="priority"
                data-cy="priority"
                type="select"
              >
                {samplePriorityValues.map(samplePriority => (
                  <option value={samplePriority} key={samplePriority}>
                    {translate(`tinyMedicRestApp.SamplePriority.${samplePriority}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.quantity')}
                id="diaglab-sample-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.collectionDate')}
                id="diaglab-sample-collectionDate"
                name="collectionDate"
                data-cy="collectionDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.revision')}
                id="diaglab-sample-revision"
                name="revision"
                data-cy="revision"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.referredToOrFrom')}
                id="diaglab-sample-referredToOrFrom"
                name="referredToOrFrom"
                data-cy="referredToOrFrom"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.sourceOfSample')}
                id="diaglab-sample-sourceOfSample"
                name="sourceOfSample"
                data-cy="sourceOfSample"
                type="select"
              >
                {sourceOfSampleValues.map(sourceOfSample => (
                  <option value={sourceOfSample} key={sourceOfSample}>
                    {translate(`tinyMedicRestApp.SourceOfSample.${sourceOfSample}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.active')}
                id="diaglab-sample-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.cursor')}
                id="diaglab-sample-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.lastUpdated')}
                id="diaglab-sample-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.microSec')}
                id="diaglab-sample-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.timestampEntry')}
                id="diaglab-sample-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.status')}
                id="diaglab-sample-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {sampleStatusValues.map(sampleStatus => (
                  <option value={sampleStatus} key={sampleStatus}>
                    {translate(`tinyMedicRestApp.SampleStatus.${sampleStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.typeOfSample')}
                id="diaglab-sample-typeOfSample"
                name="typeOfSample"
                data-cy="typeOfSample"
                type="select"
              >
                {typeOfSampleValues.map(typeOfSample => (
                  <option value={typeOfSample} key={typeOfSample}>
                    {translate(`tinyMedicRestApp.TypeOfSample.${typeOfSample}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.uom')}
                id="diaglab-sample-uom"
                name="uom"
                data-cy="uom"
                type="select"
              >
                {uOMValues.map(uOM => (
                  <option value={uOM} key={uOM}>
                    {translate(`tinyMedicRestApp.UOM.${uOM}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSample.rejectReason')}
                id="diaglab-sample-rejectReason"
                name="rejectReason"
                data-cy="rejectReason"
                type="text"
                validate={{
                  maxLength: { value: 300, message: translate('entity.validation.maxlength', { max: 300 }) },
                }}
              />
              <ValidatedField
                id="diaglab-sample-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.diaglabSample.diagLab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-sample-labBill"
                name="labBill"
                data-cy="labBill"
                label={translate('tinyMedicRestApp.diaglabSample.labBill')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabBills
                  ? diaglabBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-sample-collector"
                name="collector"
                data-cy="collector"
                label={translate('tinyMedicRestApp.diaglabSample.collector')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabAssistants
                  ? diaglabAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diaglab-sample" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiaglabSampleUpdate;
